export function formatPercentage(
  perc: number,
  minimumFractionDigits: number = 1,
  maximumFractionDigits: number = minimumFractionDigits,
) {
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(perc);
}

export function formatNumber(
  value: number,
  minimumFractionDigits: number = 1,
  maximumFractionDigits: number = minimumFractionDigits,
) {
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value);
}
